<template>
  <div class="grid grid-cols-4 gap-6">
    <NetSelect></NetSelect>
    <UiInput label="PASS contract type " modelValue="ERC721" readonly></UiInput>
    <UiInput
      v-model="formInfo.passFixedPrice.supply"
      label="Supply"
      placeholder="Optional"
      style="flex-basis: 60%"
      typeMode="INT"
    ></UiInput>
    <UiInput
      :modelValue="formInfo.passFixedPrice.platformCommission"
      label="Platform Commission"
      endTag="%"
      readonly
      style="flex-basis: 40%"
    ></UiInput>
  </div>

  <div class="grid grid-cols-2 gap-6">
    <UiInput
      v-model="formInfo.passFixedPrice.receivingAddress"
      label="Receiving address"
      required
      placeholder="Please enter your address"
      :rules="['address']"
      showError
    ></UiInput>
    <div>
      <div class="flex items-center mb-3">Sale Duration</div>

      <UiDatePicker
        class="h-14"
        v-model="formInfo.passFixedPrice.duration"
        placeholder="Please select the certain time"
        @blur="state.time = 'duration_blur'"
        @focus="state.time = 'duration_focus'"
      >
      </UiDatePicker>
    </div>
  </div>

  <div>
    <div class="flex items-center">
      NFT PASS Bot Validity
      <tippy
        content="Once you set the PASS, you can set link the PASS with The PASS Bot in discord to verify the role. This is for how long holders can enjoy the role in an exclusive community."
        placement="left"
        :arrow="false"
      >
        <i class="iconfont icon-tishi cursor-pointer ml-2 mr-6"></i>
      </tippy>
      <UiSwitch v-model="formInfo.passFixedPrice.validityStatus"></UiSwitch>
    </div>

    <div v-if="formInfo.passFixedPrice.validityStatus">
      <div
        class="rounded p-2 space-x-2 flex bg-white-005 my-3"
        style="width: fit-content"
      >
        <div
          class="
            px-6
            rounded
            flex
            items-center
            h-10
            transition-all
            cursor-pointer
            font-bold
          "
          v-for="(text, i) in validityTypes"
          :style="`background:${
            i == state.validityType
              ? 'linear-gradient(315deg, #FF5585 0%, #268CFF 100%);'
              : ''
          }`"
          @click="state.validityType = i"
          :key="i"
        >
          {{ text }}
        </div>
      </div>

      <UiDatePicker
        v-model="formInfo.passFixedPrice.certainTime"
        v-if="state.validityType == 0"
        placeholder="Please select the certain time"
        @focus="state.time = 'certain_focus'"
        @blur="state.time = 'certain_blur'"
      >
      </UiDatePicker>

      <UiInput
        v-else
        v-model="formInfo.passFixedPrice.termOfValidity"
        class="w-40"
        endTag="month"
        placeholder="0-48"
        typeMode="INT"
      ></UiInput>
    </div>
  </div>

  <div class="grid grid-cols-2 gap-6">
    <UiInput
      v-model="formInfo.passFixedPrice.payment"
      label="Payment"
      required
      placeholder="Num"
      type="number"
    ></UiInput>
    <UiDropdown
      v-model="state.paywith"
      :options="options"
      label="  "
      boxStyle="drop-height"
    ></UiDropdown>
  </div>

  <div class="grid grid-cols-2 gap-6">
    <UiInput
      v-model="formInfo.passFixedPrice.mintLimit"
      label="How many PASSes one address can mint?"
      placeholder="No need to insert if there is no limitation"
      :rules="['gtZero']"
      typeMode="Int"
    ></UiInput>

    <UiDatePicker
      placeholder="Schedule Time"
      v-model="formInfo.passFixedPrice.schedulingAhead"
      @blur="state.time = 'schedule_blur'"
      @focus="state.time = 'schedule_focus'"
    >
      <template v-slot:label>
        <div class="flex items-center mb-3 justify-between">
          <div>Scheduling ahead</div>
          <tippy
            content="If you want to create PASS at some point in the future, set the time and create it manually at that time."
            placement="left"
            :arrow="false"
          >
            <i class="iconfont icon-tishi cursor-pointer"></i>
          </tippy>
        </div>
      </template>
    </UiDatePicker>
  </div>

  <div class="flex items-center mb-3">
    Whitelist Mode
    <UiSwitch
      v-model="formInfo.passFixedPrice.isWhiteList"
      class="ml-4"
    ></UiSwitch>
  </div>
</template>

<script setup>
import UiSwitch from '@/components/UiSwitch.vue';
import { getFpPaywithOptions } from '@/constants';
import { getFpPlatformFee } from '@/constants/contract/read';
import { useNetwork } from '@/hooks';
import { notify } from '@kyvg/vue3-notification';
import dayjs from 'dayjs';
import { utils } from 'ethers';
import {
  computed,
  inject,
  onMounted,
  reactive,
  watch,
  watchEffect,
} from 'vue-demi';
import UiDropdown from '../component/UiDropdown.vue';
import NetSelect from '../component/NetSelect.vue';
import UiDatePicker from '../component/UiDatePicker.vue';
import UiInput from '../component/UiInput.vue';

const validityTypes = ['Expire at a certain time', 'Expire after a period'];

const formInfo = inject('formInfo');
const checks = inject('checks');

const network = useNetwork();
const options = computed(() =>
  getFpPaywithOptions(network.value).map((x) => ({ label: x, value: x })),
);

const checkForm = () => {
  let flag = true;
  if (
    formInfo.passFixedPrice.payment === '' ||
    +formInfo.passFixedPrice.payment < 0
  ) {
    flag = false;
  } else if (!utils.isAddress(formInfo.passFixedPrice.receivingAddress)) {
    flag = false;
  } else if (state.validityType == 0) {
    /* if (!this.certainTime) {
          flag = false;
        } else */ if (
      formInfo.passFixedPrice.certainTime &&
      formInfo.passFixedPrice.schedulingAhead &&
      dayjs(formInfo.passFixedPrice.schedulingAhead).isAfter(
        formInfo.passFixedPrice.certainTime,
      )
    ) {
      flag = false;
      notify({
        type: 'error',
        text: 'Schedule-Time without before Certain-Time!!!',
      });
    }
  } else if (formInfo.passFixedPrice.isWhiteList) {
    if (+formInfo.passFixedPrice.whiteNum < 1) {
      flag = false;
    }
  }

  if (/blur/.test(state.time)) {
    if (
      formInfo.passFixedPrice.certainTime &&
      formInfo.passFixedPrice.duration &&
      formInfo.passFixedPrice.certainTime < formInfo.passFixedPrice.duration
    ) {
      notify({
        type: 'error',
        text: 'The duration time should be ahead of Certain time',
      });
      formInfo.passFixedPrice[
        /duration/.test(state.time) ? 'duration' : 'certainTime'
      ] = '';
      flag = false;
    }

    if (
      formInfo.passFixedPrice.duration &&
      formInfo.passFixedPrice.schedulingAhead &&
      formInfo.passFixedPrice.schedulingAhead >=
        formInfo.passFixedPrice.duration
    ) {
      notify({
        type: 'error',
        text: 'The scheduling ahead time should be ahead of Duration time',
      });
      formInfo.passFixedPrice[
        /duration/.test(state.time) ? 'duration' : 'schedulingAhead'
      ] = '';
      flag = false;
    }

    if (
      formInfo.passFixedPrice.certainTime &&
      formInfo.passFixedPrice.schedulingAhead &&
      formInfo.passFixedPrice.schedulingAhead >=
        formInfo.passFixedPrice.certainTime
    ) {
      notify({
        type: 'error',
        text: 'The scheduling ahead time should be ahead of Duration time',
      });
      formInfo.passFixedPrice[
        /certain/.test(state.time) ? 'certainTime' : 'schedulingAhead'
      ] = '';
      flag = false;
    }
  }

  checks.checkFixedPrice = flag;
};

watch(
  () => JSON.stringify(formInfo.passFixedPrice),
  () => {
    checkForm();
  },
);

/*
  - certain_time
  - certain_period
 */
const state = reactive({
  validityType: formInfo.passFixedPrice.validityType == 'certain_time' ? 0 : 1,
  needExpire: false,
  paywith: {
    label: 'USDT',
    value: '',
  },
  time: '',
});

watchEffect(() => {
  formInfo.passFixedPrice.payWith = state.paywith.label;
});

onMounted(async () => {
  const x = await getFpPlatformFee(network.value);
  formInfo.passFixedPrice.platformCommission = x;
});

watch(
  () => formInfo.passFixedPrice.validityStatus,
  (status) => {
    if (!status) {
      formInfo.passFixedPrice.certainTime = '';
      formInfo.passFixedPrice.termOfValidity = '';
    }
  },
);

watch(
  () => formInfo.passFixedPrice.isWhiteList,
  (status) => {
    if (!status) {
      formInfo.passFixedPrice.fileName = '';
      formInfo.passFixedPrice.excelUuid = '';
      formInfo.passFixedPrice.whiteMode = 0;
    }
  },
);

watch(
  () => state.validityType,
  (x) => {
    formInfo.passFixedPrice.validityType =
      x == 0 ? 'certain_time' : 'certain_period';
  },
);
</script>

<style scoped>
:deep(.drop-height) {
  height: 56px;
}
</style>
